import { render } from "./indexMain.vue?vue&type=template&id=f001d176&scoped=true"
import script from "./indexMain.vue?vue&type=script&lang=js"
export * from "./indexMain.vue?vue&type=script&lang=js"

import "./indexMain.vue?vue&type=style&index=0&id=f001d176&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f001d176"]])

export default __exports__